import React from 'react';
import AppBar from '@mui/material/AppBar';
import {
  Container,
  Toolbar,
  Typography,
  Button,
  IconButton,
} from '@mui/material';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { Box } from '@mui/system';
import { Link } from 'react-router-dom';
import AspectRatio from '@mui/joy/AspectRatio';
import Grid from '@mui/material/Grid';

function Scrap() {
  return (
    <>
      <div style={{ flexGrow: 1 }}>
        <AppBar>
          <Toolbar position="static">
            <>
              <Box style={{ flexGrow: 1 }}>
                <Typography variant="h6" style={{ flexGrow: 1 }}>
                  Kei-no-suke's Page
                </Typography>
                <Link to={'/'} style={{ marginRight: 10, padding: 2 }}>
                  Home
                </Link>
                <Link to={'/scrap'} className="current" style={{ padding: 2 }}>
                  Scrap
                </Link>
              </Box>

              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2 }}
              >
                <a href="https://github.com/Kei-no-suke">
                  <i className="fa-brands fa-github white-logo"></i>
                </a>
              </IconButton>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2 }}
              >
                <a href="https://twitter.com/Kei_no_suke2309">
                  <i class="fa-brands fa-x-twitter white-logo"></i>
                </a>
              </IconButton>
            </>
          </Toolbar>
        </AppBar>
      </div>
      <div
        style={{ marginTop: '80px', marginLeft: '10px' }}
        className="Black_char"
      >
        <h2>スクラップ一覧</h2>
        <h4>
          制作済みもしくは制作するかもしれないアプリの部品となるものを掲載していく予定です。
        </h4>
      </div>
      <div style={{ marginLeft: '10px' }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <Card sx={{ maxWidth: 345 }}>
              <AspectRatio objectFit="contain">
                <CardMedia
                  component="img"
                  sx={{ height: 250 }}
                  image="./images/screenshot_simple_timer.jpg"
                  title="screenshot of simple timer"
                />
              </AspectRatio>
              <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                  Jetpack Composeを使用して作成したシンプルなタイマー
                </Typography>
                <Typography gutterBottom variant="h7" component="div">
                  掲載日時：2023年7月12日
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Jetpack Composeを使用して作成したシンプルなタイマーです。
                  <br />
                  タイマーアプリの部品として作成したもので、保存機能はついていません。
                </Typography>
                <Typography gutterBottom variant="h7" component="div">
                  追記：2023年7月13日
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  保存機能を追加しました。
                </Typography>
              </CardContent>
              <CardActions>
                <Button
                  size="small"
                  href="https://github.com/Kei-no-suke/android-compose-simple-timer/tree/main"
                  className="cardButton"
                >
                  GitHub
                </Button>
              </CardActions>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Card sx={{ maxWidth: 345 }}>
              <AspectRatio objectFit="contain">
                <CardMedia
                  component="img"
                  sx={{ height: 250 }}
                  image="./images/screenshot_bar_chart.jpg"
                  title="screenshot of simple timer"
                />
              </AspectRatio>
              <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                  Jetpack ComposeのCanvasを利用した棒グラフのサンプル
                </Typography>
                <Typography gutterBottom variant="h7" component="div">
                  掲載日時：2023年9月07日
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Jetpack ComposeのCanvasを利用した棒グラフのサンプルです。
                  軸の目盛りのテキストの幅や高さに合わせてグラフのサイズを
                  変更するようにすることで、グラフのテキストなどが範囲から
                  はみ出さないようにしました。ただし、横軸の要素を増やすと
                  テキスト同士が重なり、見づらくなる可能性があるため、
                  注意が必要です。また、縦長のスマートフォン以外の表示には
                  対応していないため、今後の課題としています。
                </Typography>
              </CardContent>
              <CardActions>
                <Button
                  size="small"
                  href="https://github.com/Kei-no-suke/android-compose-bar-chart-sample"
                  className="cardButton"
                >
                  GitHub
                </Button>
              </CardActions>
            </Card>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default Scrap;
